(function() {
'use strict'

AppTabs.createTab( {

name: 'quotes',
icon: 'file-invoice-dollar',
text: 'Quotes',
actionElementClasses: [ 'quote-link' ],
create: function(init) {

	const tab = this;
	const quoteView = AppTabs.getTab('quote').controller;
	const fields = [
		{
			label: 		'Quote ID',
			columnName: 'QuoteID',
			order:		'desc',
			render: 	function( data, type, row ) {
				return '<a data-quote-id="' + data + '" href="quoteID:' + data + '" class="quote-link" >' + data + '</a>';
			},
		},
		{
			label: 		'Client',
			columnName: 'Client',
		},
		{
			label: 		'Project',
			columnName: 'QuoteProject',
		},
		{
			label: 		'Quote Date',
			columnName: 'QuoteDate',
			type:       'date', // This makes filtering counter-intuitive
		},
	];

	init.setDataTableArgs( {

		tableId: 		'#datatable-quote-list',

		// tables used by DataTables actions
		readTableName: 	'viewQuoteList',
		editTableName: 	null,

		primaryKey: 	'QuoteID',

		hasColumnFilters: 	true,
		canSearch: 			true,
		canSort:			true,

		pagelength:			10,

		// Ajax action endpoints
		// these also serve as flags as to whether to show the editor buttons or add the autofill eventListener
		actionData:			'datatable',

		fields: fields,
	} );

	const quoteLineItem = {
		template: '#quote-line-item-component',
		props: {
			'data': Object,
		},
		computed: {
			extendedTotal: function() {
				return '$' + ( this.data.Charge * this.data.Qty ).toFixed( 2 );
			}
		}
	};

    init.setController( new TabControllerVue({
        el: '#v-quote',
		components: {
			'quote-line-item': quoteLineItem,
	    },
		computed: {
			// data store
			clients: x => store.state.clientList,
            priceListItems: x => store.state.priceList,
			// state accessor encapsulation
			quoteIsSelected: function() {
				return this.quoteId != 0;
			},
			isNewQuote: function() {
				return this.quoteId == -1;
			},
			isExistingQuote: function() {
				return this.quoteId > 0;
			},
			//
			clientName: function() {
				if ( this.client != null ) {
					return this.client.text;
				} else {
					return '';
				}
			},
			testedSubstances: function() {
				return [...new Set( this.quoteLineItems ? this.quoteLineItems.map( lineItem => lineItem.TestedSubstance ) : [] )]
					.filter( x => x );
			},
			categories: function() {
				return [...new Set( this.quoteLineItems ? this.quoteLineItems.map( lineItem => lineItem.Category ) : [] )]
					.filter( x => x );
			},
			selectedQuoteItems: function() {
				return this.quoteLineItems ? this.quoteLineItems.filter( lineItem => lineItem.selected ) : [];
			},
			filteredQuoteLineItems: function() {
				let filteredQuoteLineItems = this.quoteLineItems;

				if ( this.itemFilter ) {
					const itemFilter = this.itemFilter.toLowerCase();
					filteredQuoteLineItems = filteredQuoteLineItems
						.filter( lineItem => lineItem != null && lineItem.Item != null && lineItem.Item.toLowerCase().indexOf( itemFilter ) != -1 );
				}
				if ( this.methodFilter ) {
					const methodFilter = this.methodFilter.toLowerCase();
					filteredQuoteLineItems = filteredQuoteLineItems
						.filter( lineItem => lineItem != null && lineItem.Method != null && lineItem.Method.toLowerCase().indexOf( methodFilter ) != -1 );
				}
				if ( this.showSelectedOnly ) {
					filteredQuoteLineItems = filteredQuoteLineItems
						.filter( lineItem => lineItem.selected );
				}
				if ( this.testedSubstance ) {
					const testedSubstance = this.testedSubstance;
					filteredQuoteLineItems = filteredQuoteLineItems
						.filter( lineItem => lineItem.TestedSubstance == testedSubstance );
				}
				if ( this.category ) {
					const category = this.category;
					filteredQuoteLineItems = filteredQuoteLineItems
						.filter( lineItem => lineItem.Category == category );
				}

				return filteredQuoteLineItems;
			},
		},
		methods: {
			resetData() {
				// dynamic quote info used in all quotes
				this.quoteInfo      = {};
				this.quoteLineItems = [];
				this.quoteId        = 0; // 0 for no quote; -1 for new quotes; a valid id from tblQuotes for existing quotes

				// Quote info for existing clients
				this.client    = null;
				this.address   = null;
				this.addresses = [];

				// Filters
				this.itemFilter       = '';
				this.methodFilter     = '';
				this.testedSubstance  = null;
				this.category         = null;
				this.showSelectedOnly = false;

				// flag to determine if viewing header
				this.headerIsVisible = true;

				// flags for loading indicators
				this.fetchingQuote     = false;
				this.fetchingAddresses = false;

				// flag for indicating if the quote has changed but hasn't been saved
				this.quoteDataModified =	false;
			},
			confirmAndDelete: function() {
				window.ConfirmationModalManager.show({
					title: 'Delete Current Quote',
					message: 'Are you sure you want to permanently delete the current quote?',
					callback: this.deleteQuote,
				});
			},
			confirmAndClear: function() {
				if ( ! this.quoteDataModified ) {
					this.clear();
					return;
				} else {
					window.ConfirmationModalManager.show({
						title: 'Discard Changes to Current Quote',
						message: 'Are you sure you want to discard the changes you have made to the current quote without saving them?',
						callback: this.clear,
					});
				}
			},
			clear: function() {
				this.quoteId = 0;
				this.quoteInfo = [];
				this.quoteLineItems = [];
				this.viewHeader();
			},
			deleteQuote: function() {
				window.ajaxCall({
                    data : {
						action: 'delete_quote',
						quoteID: this.quoteId,
					},
                    onSuccess : tab.drawTable,
                });
				this.clear();
			},
			populateQuoteItems: function( lineItems ) {
				this.quoteLineItems = this.priceListItems.map( function( priceListItem ) {
					const priceListID = priceListItem.PriceListID;
					let quoteLineItem = lineItems ? lineItems.find( quoteLineItem => priceListID == quoteLineItem.PriceListID ) : undefined;

					if ( quoteLineItem != undefined ) {
						quoteLineItem.selected = true;
					} else {
						quoteLineItem = JSON.parse( JSON.stringify( priceListItem ) );
						quoteLineItem.selected = false;
					}

					return quoteLineItem;
				});
			},
			populateNewQuoteData: function() {
				this.quoteInfo.QuoteDate = 			moment().format( 'YYYY-MM-DD' );
				this.quoteInfo.QuoteEffStartDate = 	moment().format( 'YYYY-MM-DD' );
				this.quoteInfo.QuoteEffEndDate = 	moment().endOf( 'year' ).format( 'YYYY-MM-DD' );
				this.quoteInfo.QuoteDiscountPercent = 0;

				this.quoteInfo.QuoteManager = null;
				this.quoteInfo.QuoteManagerTitle = null;
				this.quoteInfo.QuoteParagraph1 = null;
				this.quoteInfo.QuoteParagraph2 = null;
				this.quoteInfo.QuoteClosing = 'Best Regards,';
				this.quoteInfo.CompanyName = null;
				this.quoteInfo.QuoteManagerSignature = null;
				this.quoteInfo.QuoteTerms = null;

				const _this = this;
				window.ajaxCall({
                    data : {
						action: 'get_quote_defaults',
					},
                    onSuccess : function( response ) {
						const data = response.data;
						console.log( data );

						_this.quoteInfo.QuoteManager = data.manager;
						_this.quoteInfo.QuoteManagerTitle = data.managerTitle;
						_this.quoteInfo.QuoteParagraph1 = data.paragraph1;
						_this.quoteInfo.QuoteParagraph2 = data.paragraph2;
						_this.quoteInfo.CompanyName = data.CompanyName;
						_this.quoteInfo.QuoteManagerSignature = data.managerSignature;
						_this.quoteInfo.QuoteTerms = data.terms;

						_this.$forceUpdate(); // needed since this is wired up with an object instead
                    },
                });

			},
			populateNewClientQuoteData: function() {
				if ( this.client ) {
					this.quoteInfo.CustomerAddressLine1 = this.client.text;
					if ( this.address ) {
						this.quoteInfo.CustomerAddressLine2 = this.address.Address1;
						this.quoteInfo.CustomerAddressLine3 = this.address.Address2;
						this.quoteInfo.CustomerAddressLine4 = this.address.Address3;
					}
				}
			},
			addNewQuoteItem: function() {
				this.newQuoteItem = true;
				this.quoteLineItems.unshift({
					selected: 	true,
					Qty: 		1,
					Charge: 	0,
				});
			},
			createNewQuote: function() {
				this.quoteId = -1;
				this.quoteInfo = {};
				this.populateNewQuoteData();
				this.populateQuoteItems( [] );
				this.viewHeader();
				const callback = this.resetQuoteModifiedFlag;
				window.requestAnimationFrame( callback );
			},
			createNewQuoteForClient: function() {
				this.quoteId = -1;
				this.quoteInfo = {};
				this.populateNewQuoteData();
				this.populateNewClientQuoteData();
				this.populateQuoteItems( [] );
				this.viewHeader();
				const callback = this.resetQuoteModifiedFlag;
				window.requestAnimationFrame( callback );
			},
			resetQuoteModifiedFlag: function() {
				this.quoteDataModified = false;
			},
			confirmDiscount: function() {
				this.quoteInfo.QuoteDiscountPercent = parseFloat( this.quoteInfo.QuoteDiscountPercent );
				if ( isNaN( this.quoteInfo.QuoteDiscountPercent )
					|| this.quoteInfo.QuoteDiscountPercent < 0
					|| this.quoteInfo.QuoteDiscountPercent > 100
				) {
					window.WarningModalManager.show({
						title:		'Invalid Discount Percentage',
						message:	'Discount must be between 0 and 100%.',
					});
					this.quoteInfo.QuoteDiscountPercent = 0;
				} else {
					window.ConfirmationModalManager.show({
						title: 'Discount Confirmation',
						message: 'Are you sure you want to replace the current prices by applying a '
							+this. quoteInfo.QuoteDiscountPercent + '% discount to the list pricing for each item?',
						callback: this.applyDiscount,
					});
				}
			},
			applyDiscount: function() {
				const _this = this;
				this.quoteLineItems.forEach( function( quoteLineItem ) {
					const priceListID = quoteLineItem.PriceListID;
					const priceListItem = _this.priceListItems.find( priceListItem => priceListID == priceListItem.PriceListID );

					if ( priceListItem && priceListItem.Charge ) {
						quoteLineItem.Charge = ( priceListItem.Charge * ( 100 - _this.quoteInfo.QuoteDiscountPercent ) / 100 ).toFixed( 2 );
					}
				});
			},
			exportQuoteDocument: function() {
				//window.open( '/quote/?quoteId=' + this.quoteId );
				quoteView.OpenQuote( this.quoteId );
			},
			saveQuote: function() {
				// block ui?

				const _this = this;
				const callback = function() {
					//Reload Price List local data after adding a new quote item
					window.LocalStorageManager.loadField('priceList').then(
						function() {
							_this.refreshQuote();
						}
					)
					_this.refreshQuote();
					_this.resetQuoteModifiedFlag();
					tab.drawTable();
				};

				window.ajaxCall({
                    data : {
						action: 'update_quote',
						quoteID: this.quoteId,
						quoteInfo: this.quoteInfo,
						quoteLineItems: this.selectedQuoteItems,
					},
                    onSuccess : function( response ) {
						_this.quoteId = response.data;
						callback();
                    },
                });
			},
			refreshQuote: function() {
				if ( this.quoteId ) {
					this.ajaxLoadExistingQuote( this.quoteId );
				}
			},
			ajaxLoadAddresses: function() {
				const _this = this;
				_this.fetchingAddresses = true;

				window.ajaxCall({
					data : {
						action: 'get_addresses_with_parts_by_client',
						clientId: this.client.id,
					},
					onSuccess : function( response ) {
						_this.addresses = response.data;
						if ( _this.addresses && _this.addresses.length > 0 ) {
							_this.address = _this.addresses[0];
						}
					},
					onError : function( response ) {
						alert( 'Could not load Addresses for ' + _this.client.text );
					},
					onComplete : function() {
						_this.fetchingAddresses = false;
					},
				});
			},
			ajaxLoadExistingQuote: function( quoteID, onSuccess = null ) {
				const _this = this;
				const callback = this.resetQuoteModifiedFlag;
				this.quoteId = quoteID;
				this.quoteInfo = [];
				this.quoteLineItems = [];
				this.viewHeader();
				window.ajaxCall({
                    data : {
                        action: 'get_quote_info_by_id',
						quoteID: quoteID,
                    },
                    onSuccess : function( response ) {
                        _this.quoteInfo = response.data;
						window.requestAnimationFrame( callback );
						typeof onSuccess == 'function' && onSuccess();
                    },
                });
				window.ajaxCall({
                    data : {
                        action: 'get_quote_line_items_by_id',
						quoteID: quoteID,
                    },
                    onSuccess : function( response ) {
						_this.populateQuoteItems( response.data );
						window.requestAnimationFrame( callback );
                    },
                });
			},
			viewHeader: function() {
				this.headerIsVisible = true;
				AppTabs.redraw();
			},
			viewBody: function() {
				this.headerIsVisible = false;
			},

			doElementAction: function(target, elClass, event) {
                this.ajaxLoadExistingQuote( target.dataset.quoteId, tab.show );
			},
		},
		watch: {
			client: function( newValue, oldValue ) {
				this.addresses = [];
				if ( null == newValue ) {
					return;
				}
				this.ajaxLoadAddresses();
			},
			quoteLineItems: {
				handler: function() {
					this.quoteDataModified = true;
				},
				deep: true,
			},
			quoteInfo: {
				handler: function() {
					this.quoteDataModified = true;
				},
				deep: true,
			},
		},
	}) );

}

});

})();